import { FC } from 'react'
import cx from 'classnames'

import { LinkProps } from '../Link'
import { Icons } from '../Icon'

import * as SC from './styled'

export type HeaderExternalProps = LinkProps

const HeaderExternal: FC<HeaderExternalProps> = ({
  className,
  ...linkProps
}) => {
  return (
    <SC.Container className={cx('HeaderExternal', className)} {...linkProps}>
      <SC.Label>
        {linkProps.children || linkProps.label || linkProps.text}
      </SC.Label>
      <SC._Icon icon={Icons.arrowTopRight} aria-hidden />
    </SC.Container>
  )
}

export default HeaderExternal
